import { useEffect, useState } from "react";
import { Grid2 } from "@mui/material";
import Box from '@mui/material/Box';
import { MenuItem } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import '../Orders.css'
import CheckIcon from '@mui/icons-material/Check';
import { Pagination } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import { getTransactionHistory } from "../../../Actions/transactionAction";
import { useDispatch, useSelector } from "react-redux";
import { getAssets } from "../../../Actions/AssetsAction";
import { useSearchParams } from "react-router-dom";
import { Skeleton } from "@mui/material";
import NoDataFound from "../../NoDataFound/NoDataFound";
import { Search, SearchIconWrapper, StyledInputBase } from "../../common/SearchInput";


const TimeOption = [
    { label: "All", value: "" },
    { label: "Last 7 days", value: "7d" },
    { label: "Last 30 days", value: "30d" },
    { label: "Last 90 days", value: "90d" },
];

function DepositHistory() {
    const dispatch = useDispatch();
    const [searchQuery, setSearchQuery] = useState("");
    const [age2, setAge2] = useState(""); // selected coin
    const [open2, setOpen2] = useState(false);
    const [age4, setAge4] = useState("");
    const [open4, setOpen4] = useState(false);

    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value.toLowerCase());
    };

    const { list: transactionList, loading: transactionLoading, error: transactionError, pagination: transactionPagination } = useSelector((state) => state.transaction);

    const [searchParams, setSearchParams] = useSearchParams();
    const pageFromUrl = parseInt(searchParams.get("page")) || 1;
    const [currentPage, setCurrentPage] = useState(pageFromUrl);
    const limit = 10;

    const handleChangePage = (event, value) => {
        setCurrentPage(value);
        setSearchParams({ page: value });
    };

    // Use transactionList directly since backend handles filtering and pagination
    const filteredTransactions = transactionList;
    const totalPages = transactionPagination?.totalPages || 1;
    const displayedTransactions = transactionList;

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const datePart = date.toLocaleString('en-US', { month: 'long', day: 'numeric' });
        const timePart = date.toLocaleString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            year: 'numeric',
            hour12: true,
        });
        return `${datePart},${timePart}`;
    };

    const DepositHistoryTable = (
        <Table
            sx={{ minWidth: 400, background: "var(--color-BasicBg)", scrollbarWidth: 'none' }}
            stickyHeader
            aria-label="sticky table"
        >
            <TableHead sx={{ background: 'var(--color-BasicBg)' }}>
                <TableRow>
                    <TableCell style={{ whiteSpace: 'nowrap' }}>S.No.</TableCell>
                    <TableCell style={{ whiteSpace: 'nowrap' }}>Date</TableCell>
                    <TableCell style={{ whiteSpace: 'nowrap' }}>Txn Hash</TableCell>
                    <TableCell style={{ whiteSpace: 'nowrap' }}>Txn Id</TableCell>
                    <TableCell style={{ whiteSpace: 'nowrap' }}>Deposit Address</TableCell>
                    <TableCell style={{ whiteSpace: 'nowrap' }}>Currency</TableCell>
                    <TableCell style={{ whiteSpace: 'nowrap' }}>Amount</TableCell>
                    <TableCell style={{ whiteSpace: 'nowrap' }}>Status</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {transactionLoading ? (
                    [...Array(8)]?.map((_, rowIndex) => (
                        <TableRow key={rowIndex}>
                            {[...Array(8)]?.map((_, colIndex) => (
                                <TableCell key={colIndex}>
                                    <Skeleton
                                        variant="text"
                                        height={30}
                                        sx={{ backgroundColor: '#333', borderRadius: 1 }}
                                    />
                                </TableCell>
                            ))}
                        </TableRow>
                    ))
                ) : filteredTransactions?.length === 0 ? (
                    <TableRow>
                        <TableCell colSpan={8} align="center">
                            <NoDataFound message="No deposit record found" />
                        </TableCell>
                    </TableRow>
                ) : (
                    displayedTransactions?.map((item, index) => (
                        <TableRow key={item._id}>
                            <TableCell style={{ whiteSpace: 'nowrap' }}>
                                {(currentPage - 1) * limit + index + 1}
                            </TableCell>
                            <TableCell style={{ whiteSpace: 'nowrap' }}>
                                {item?.postedAt ? formatDate(item.postedAt) : formatDate(item.createdAt)}
                            </TableCell>
                            <TableCell style={{ whiteSpace: 'nowrap' }}>{item?.txHash || '-'}</TableCell>
                            <TableCell style={{ whiteSpace: 'nowrap' }}>{item?.txId || '-'}</TableCell>
                            <TableCell style={{ whiteSpace: 'nowrap' }}>{item?.depositAddress || '-'}</TableCell>
                            <TableCell style={{ whiteSpace: 'nowrap' }}>{item?.coin || '-'}{item?.network ? ` (${item?.network})` : ''}</TableCell>
                            <TableCell style={{ whiteSpace: 'nowrap' }}>{item?.amount?.$numberDecimal ?? item.amount ?? 0}</TableCell>
                            <TableCell style={{ whiteSpace: 'nowrap' }}>{item?.status || '-'}</TableCell>
                        </TableRow>
                    ))
                )}
            </TableBody>
        </Table>
    );

    const assetsState = useSelector(state => state.assets);
    const { assetsData } = assetsState;
    const { userDetailData, isFirstLoad, userDetailStatus } = useSelector((state) => state.user);

    const [selectedAsset, setSelectedAsset] = useState(null);

    useEffect(() => {
        if (!assetsData) {
            dispatch(getAssets());
        }
    }, [dispatch, assetsData]);

    useEffect(() => {
        if (assetsData && assetsData.length > 0 && !selectedAsset) {
            setSelectedAsset(assetsData[0]);
        }
    }, [assetsData, selectedAsset]);

    const CoinOption = assetsData?.filter((coin) => coin?.source === "USDT")?.map(item => ({
        label: item.source,
        value: item.source,
        img: item.image ? `${process.env.REACT_APP_BACKEND_URL.replace(/\/$/, "")}/${item.image.replace(/^\//, "")}` : null
    })) || [];

    const filteredCoinOptions = CoinOption.filter(option =>
        option.label.toLowerCase().includes(searchQuery.toLowerCase())
    );

    useEffect(() => {
        if (userDetailData) {
            const payload = {
                page: currentPage,
                limit: limit,
                period: age4 || undefined, // Pass period to backend API
                currency: age2 || undefined, // Pass selected coin to backend API
                type: "deposit" // Filter by deposit type
            };
            dispatch(getTransactionHistory(payload));
        }
    }, [dispatch, currentPage, age4, age2, limit]);

    return (
        <Grid2 container spacing={2} className="mt-20">
            {/* <Grid2 item size={{ xs: 12, sm: 6, md: 4, lg: 3, xl: 2 }}>
                <div
                    className="input-common Select-Filter-main"
                >
                    <div className="Select-Filter-name">
                        <p>Time</p>
                    </div>
                    <FormControl fullWidth>
                        <Select
                            value={age4}
                            onChange={(e) => setAge4(e.target.value)}
                            displayEmpty
                            renderValue={(selected) => {
                                if (!selected) return (
                                    <span style={{ color: 'var(--color-PrimaryText)', fontSize: '12px' }}>
                                        All
                                    </span>
                                );
                                const selectedItem = TimeOption.find(item => item.value === selected);
                                return (
                                    <span style={{ color: 'var(--color-PrimaryText)', fontSize: '12px' }}>
                                        {selectedItem?.label || 'Filter'}
                                    </span>
                                );
                            }}
                            sx={{
                                color: "var(--color-PrimaryText)",
                                fontSize: "12px",
                                "& .MuiSelect-icon": { color: "var(--color-PrimaryText)" },
                                textAlign: 'end'
                            }}
                        >
                            {TimeOption.map(option => (
                                <MenuItem
                                    key={option.value}
                                    value={option.value}
                                    sx={{
                                        fontSize: '12px',
                                        color: 'var(--color-PrimaryText)',
                                        textAlign: 'start',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                    }}
                                >
                                    {option.label}
                                    {age4 === option.value && <CheckIcon fontSize="small" />}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>
            </Grid2>

            <Grid2 item size={{ xs: 6, sm: 6, md: 4, lg: 3, xl: 2 }}>
                <div
                    className="input-common Select-Filter-main"
                >
                    <div className="Select-Filter-name">
                        <p>Coin</p>
                    </div>
                    <FormControl fullWidth>
                        <Select
                            value={age2}
                            onChange={(e) => setAge2(e.target.value)}
                            displayEmpty
                            open={open2}
                            onClose={() => setOpen2(false)}
                            onOpen={() => setOpen2(true)}
                            renderValue={(selected) => {
                                if (!selected) return (
                                    <span style={{ color: 'var(--color-PrimaryText)', fontSize: '12px' }}>
                                        All
                                    </span>
                                );
                                const selectedItem = CoinOption.find(item => item.value === selected);
                                return (
                                    <span style={{ color: 'var(--color-PrimaryText)', fontSize: '12px' }}>
                                        {selectedItem?.label || 'Filter'}
                                    </span>
                                );
                            }}
                            sx={{
                                color: "var(--color-PrimaryText)",
                                fontSize: "12px",
                                "& .MuiSelect-icon": { color: "var(--color-PrimaryText)" },
                                textAlign: 'end'
                            }}
                        >
                            <MenuItem
                                value=""
                                sx={{
                                    fontSize: '12px',
                                    color: 'var(--color-PrimaryText)',
                                    textAlign: 'start',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    padding: "0px "
                                }}
                                disableRipple
                            >
                                <div className="category-search-box-car1 srch" style={{ placeContent: "center" }} onClick={(e) => e.stopPropagation()}>
                                    <Search className='search-crs' >
                                        <SearchIconWrapper>
                                            <SearchIcon sx={{ color: 'var(--color-PrimaryText)' }} />
                                        </SearchIconWrapper>
                                        <StyledInputBase
                                            sx={{ width: '100%' }}
                                            placeholder="Search"
                                            inputProps={{ 'aria-label': 'search' }}
                                            value={searchQuery}
                                            onChange={handleSearchChange}
                                        />
                                    </Search>
                                </div>
                            </MenuItem>
                            <MenuItem
                                value=""
                                sx={{
                                    fontSize: '12px',
                                    color: 'var(--color-PrimaryText)',
                                    textAlign: 'start',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                }}
                            >
                                All
                            </MenuItem>
                            {filteredCoinOptions.map(option => (
                                <MenuItem
                                    key={option.value}
                                    value={option.value}
                                    sx={{
                                        fontSize: '12px',
                                        color: 'var(--color-PrimaryText)',
                                        textAlign: 'start',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                    }}
                                ><div className="display-1">
                                        <img width={20} src={option.img} />
                                        {option.label}
                                    </div>
                                    {age2 === option.value && <CheckIcon fontSize="small" />}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>
            </Grid2> */}

            <Grid2 item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                <TableContainer sx={{ maxHeight: 440, borderRadius: '12px 12px 12px 12px', scrollbarWidth: 'none' }}>
                    {DepositHistoryTable}
                </TableContainer>
                {!transactionLoading && filteredTransactions?.length > 0 && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                        <Pagination
                            key={totalPages}
                            count={totalPages}
                            page={currentPage}
                            onChange={handleChangePage}
                            color="primary"
                            boundaryCount={1}
                            siblingCount={1}
                            sx={{
                                '& .MuiPaginationItem-root': {
                                    color: 'var(--color-PrimaryText)',
                                },
                                '& .Mui-selected': {
                                    backgroundColor: '#E2A52D !important',
                                    color: '#000 !important',
                                    '&:hover': {
                                        backgroundColor: '#E2A52D !important',
                                    },
                                },
                            }}
                        />
                    </Box>
                )}
            </Grid2>
        </Grid2>
    );
}

export default DepositHistory;
